import TextArea, { TextAreaProps } from './TextArea';

export type { TextAreaProps };
export default TextArea;
